import { coreAxios } from "utilities/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

const BASE_URL = process.env.REACT_APP_MAIN_URL

export const GetCategories = createAsyncThunk(
  "dropdown/GetCategories",
  async () => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/category/list/`);
    return data
  }
);

export const GetRequisitionTypes = createAsyncThunk(
  "dropdown/GetRequisitionTypes",
  async () => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/requisitionType/list/`);
    return data
  }
);

export const GetSupplierNames = createAsyncThunk(
  "dropdown/GetSupplierNames",
  async () => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/supplier/name/list/`);
    return data
  }
);

export const GetProductNames = createAsyncThunk(
  "dropdown/GetProductNames",
  async () => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/product/name/list/`);
    return data
  }
);

export const GetRequisitionNames = createAsyncThunk(
  "dropdown/GetRequisitionNames",
  async (requisitionType) => {
    const {data} = await coreAxios.post(`${BASE_URL}/api/requisition/name/list/`, requisitionType)
    return data
  }
);

export const GetWorkOrderNames = createAsyncThunk(
  "dropdown/GetRequisitionNames",
  async (workOrder) => {
    const {data} = await coreAxios.post(`${BASE_URL}/api/work/order/name/list/`, workOrder)
    return data
  }
);

export const GetChalanNames = createAsyncThunk(
  "dropdown/GetChalanNames",
  async () => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/chalan/name/list/`)
    return data
  }
);

export const GetUserTypes = createAsyncThunk(
  "dropdown/GetUserTypes",
  async () => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/user/type/list/`)
    return data
  }
);